"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendFileStore = void 0;
const lincd_server_1 = require("../ontologies/lincd-server");
const package_1 = require("../package");
const FrontendStore_1 = require("./FrontendStore");
/**
 * A store on the frontend that loads all contents into memory on initialisation
 * And passes all changes to the provider on the backend
 * @see FrontendFileStoreProvider
 */
let FrontendFileStore = class FrontendFileStore extends FrontendStore_1.FrontendStore {
    constructor(n) {
        if (typeof n === 'string') {
            super();
            this.label = n;
        }
        else {
            super(n);
        }
    }
};
FrontendFileStore.targetClass = lincd_server_1.lincdServer.FrontendFileStore;
FrontendFileStore = __decorate([
    package_1.linkedShape
], FrontendFileStore);
exports.FrontendFileStore = FrontendFileStore;
//# sourceMappingURL=FrontendFileStore.js.map